
const getBasketCodes = (uiContext, isBusinessUser) => {
    return isBusinessUser ? uiContext.baskets?.businessCodes : uiContext.baskets?.individualCodes;
}

export {getBasketCodes}